export enum PurposeTypeEnum {
  RESALE = 'resale',
  INTERNAL_USAGE = 'internal_usage'
}
